/**
 * Detekts Internet Explorer version number.
 * Desides if it is older IE or Edge.
 * Adds 'msie' or 'edge' class to body element respectively.
 */

function getIEversion() {
	let ua = window.navigator.userAgent;
	let msie = ua.indexOf('MSIE ');
	let trident = ua.indexOf('Trident/');
	let edge = ua.indexOf('Edge/');
	let version = false;

	if (msie > 0) {
		// IE 10 or older => return version number
		version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	if (trident > 0) {
		// IE 11 => return version number
		let rv = ua.indexOf('rv:');
		version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	if (edge > 0) {
		// Edge (IE 12+) => return version number
		version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	return version;
}

function getIEtype() {
	let version = getIEversion();
	let type;

	if (version === false) {
		type = null; // it is not an IE
	} else if (version >= 12) {
		type = 'edge';
	} else {
		type = 'msie';
	}

	return type;
}

export default function addIEBodyClass() {
	let ieType = getIEtype();

	console.log("Is it IE?", ieType);

	if (ieType) {
		document.body.classList.add(ieType);
	}
}



// WEBPACK FOOTER //
// ../source/common/detect-ie/detect-ie.js